import * as go from 'gojs/release/go-module';

import { DiagramTransaction } from 'src/containers/ProjectDiagram/constants/transactions';
import { Diagram } from 'src/containers/ProjectDiagram/types/diagram';
import { commitDiagramWhileSkippingUndoManager } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import {
  isLink,
  isLinkLabel,
  isNode,
} from 'src/containers/ProjectDiagram/utils/graphObject';
import { setDiagramHighlight } from 'src/containers/ProjectDiagram/utils/setDiagramHighlight';

export const graphObjectMouseEnter: NonNullable<
  go.GraphObject['mouseEnter']
> = (e, targetObject: go.GraphObject) => {
  const graphObject = targetObject.part || targetObject;
  const highlights = new go.Set<go.Part>([]);
  if (isNode(graphObject)) {
    highlights.add(graphObject);
  } else if (isLinkLabel(graphObject)) {
    highlights.add(graphObject);
    if (graphObject.labeledLink) {
      highlights.add(graphObject.labeledLink);
    }
  } else if (isLink(graphObject)) {
    highlights.add(graphObject);
    highlights.addAll(graphObject.labelNodes);
  }

  if (highlights.size) {
    commitDiagramWhileSkippingUndoManager(
      e.diagram as Diagram,
      (_, diagram) => setDiagramHighlight(highlights)(diagram),
      DiagramTransaction.SET_DIAGRAM_HIGHLIGHT
    );
  }
};

export const graphObjectMouseLeave: NonNullable<
  go.GraphObject['mouseLeave']
> = (e) => {
  commitDiagramWhileSkippingUndoManager(
    e.diagram as Diagram,
    (_, diagram) => setDiagramHighlight()(diagram),
    DiagramTransaction.SET_DIAGRAM_HIGHLIGHT
  );
};
